import React from 'react';
import { Button } from '@mui/material';
import SearchBar from '../../../../shared/components/search-bar/search-bar';

interface Props {
  onSearchTermChange: (searchTerm: string) => void,
  setIsCreateTaskModalOpen: (isCreateTaskModalOpen: boolean) => void,
}

export default function TopLayout({ onSearchTermChange, setIsCreateTaskModalOpen }: Props) {
  return (
    <div className="flex flex-row justify-between">
      <Button variant="contained" onClick={() => setIsCreateTaskModalOpen(true)}>
        Novo Serviço
      </Button>
      <div className="h-full">
        <SearchBar onSearchTermChange={onSearchTermChange} />
      </div>
    </div>
  );
}
